import React, { ReactNode } from "react"
import { useAuth } from "@/hooks/useAuth" // Adjust the import path as necessary
import { APP_ROUTES } from "@/common/urls"
import { Skeleton } from "@/components/ui/skeleton"
import { Navigate } from "react-router-dom"

interface ProtectedRouteProps {
    children: ReactNode
}

const ProtectedRoute: React.FC<ProtectedRouteProps> = ({ children }) => {
    const { user, loading } = useAuth()

    if (loading) {
        return <Skeleton className="w-full h-full" />
    }

    if (!user) {
        return <Navigate to={APP_ROUTES.AUTH.LOGIN} />
    }

    return <>{children}</>
}

export default ProtectedRoute
